var _sentryCollisionFreeGlobalObject = typeof window === "undefined" ? global : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"219a9e1b7a031f879e842db49d9e47c489ac431c"};
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from "@sentry/nextjs";

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

if (process.env.DOMAIN_NAME != "https://staging.luminews.my") {
  Sentry.init({
    dsn:
      SENTRY_DSN ||
      "https://cbd17b5f1bd24cf2b039d0b106279292@o678955.ingest.sentry.io/5769384",
    // Adjust this value in production, or use tracesSampler for greater control
    tracesSampleRate: 0.2,
    // ...
    // Note: if you want to override the automatic release value, do not set a
    // `release` value here - use the environment variable `SENTRY_RELEASE`, so
    // that it will also get attached to your source maps
    ignoreErrors: [
      // https://luminews.sentry.io/issues/5669245875/?project=5769384&query=is%3Aunresolved%20issue.priority%3A%5Bhigh%2C%20medium%5D&referrer=issue-stream&stream_index=14
      // https://github.com/getsentry/sentry-javascript/issues/15065
      "Java exception was raised during method invocation",
      // Mostly to ignore errors from Taboola.
      // https://luminews.sentry.io/issues/?project=5769384&query=is%3Aunresolved%20issue.priority%3A%5Bhigh%2C%20medium%5D%20Failed%20to%20fetch&referrer=issue-list&statsPeriod=90d
      // https://forum.sentry.io/t/typeerror-failed-to-fetch-reported-over-and-overe/8447
      "TypeError: Failed to fetch",
      // https://luminews.sentry.io/issues/6124413440/?project=5769384&query=is%3Aunresolved%20issue.priority%3A%5Bhigh%2C%20medium%5D&referrer=issue-stream&stream_index=1
      "property 'javaEnabled' is a read-only",
      // https://luminews.sentry.io/issues/5669245875/?project=5769384&query=is%3Aunresolved%20issue.priority%3A%5Bhigh%2C%20medium%5D&referrer=issue-stream&stream_index=0
      "Java object is gone",
      // safari code extension problem that can be safely ignored
      "webkit-masked-url",
      // These types of events are caused when a rejection is raised with a non-error object, from which we cannot extract much information (response from Sentry support)
      "Non-Error promise rejection captured",

      // vodus specific, can't find the cause yet.
      "vodus is not a function",
    ],
  });
}
